import { memo } from 'react';
import type { CustomBrandDivision, Brand } from '@apiTypes';
import styles from './BrandsList.module.scss';
import BrandItem from './BrandItem/BrandItem';
import BrandsListDivisions from './BrandsListDivisions';

const BrandsList = ({
    brands,
    divisions,
    onBrandSelect,
}: {
    brands: Brand[];
    divisions: CustomBrandDivision[];
    onBrandSelect?: () => void;
}) => {
    const hasDivisions = divisions.length > 0;

    return (
        <div className={styles.container}>
            {hasDivisions ? (
                <BrandsListDivisions
                    brands={brands}
                    divisions={divisions}
                    onBrandSelect={onBrandSelect}
                />
            ) : (
                <div className={styles.grid}>
                    {brands.map(brand => (
                        <BrandItem
                            key={brand.name}
                            brand={brand}
                            onBrandSelect={onBrandSelect}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default memo(BrandsList);
